import { render } from "./EmailAvaliacaoModal.vue?vue&type=template&id=4c2f0376&scoped=true"
import script from "./EmailAvaliacaoModal.vue?vue&type=script&lang=js"
export * from "./EmailAvaliacaoModal.vue?vue&type=script&lang=js"

import "./EmailAvaliacaoModal.vue?vue&type=style&index=0&id=4c2f0376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2f0376"]])

export default __exports__